export let focusableElements =
  'button, a, input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
